const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        sorter: (a, b) => a?.name?.localeCompare(b?.name),
    },
    {
        title: 'Fees / Commission(%)',
        dataIndex: 'fees',
    },
    {
        title: 'Processing Time',
        dataIndex: 'processingTime',
    },
    {
        title: '',
        dataIndex: 'status',
        width: 100
    }
];

export default columns;